<template>
  <div>
    <template v-if="merchantPayments === true">
      <div v-show="isDataTableLoading === false">
        <div class="page-top mb-1 mb-3 align-left clearfix">
          <h1> Merchant Payments</h1>
        </div>
        <div class="page-top mb-1 mb-3 clearfix">
          <ul class="nav nav-tabs nav-tabs-1 float-left" id="myTab" role="tablist">
            <li class="nav-item">
              <a class="nav-link active" id="processed-tab" data-toggle="tab" href="#processed" role="tab"
                 aria-controls="processed" aria-selected="false"
                 @click="reloadList('processed')">Processed</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" id="error-tab" data-toggle="tab" href="#error" role="tab"
                 aria-controls="error" aria-selected="false" @click="reloadList('error')">Error
                </a>
            </li>
          </ul>
        </div>
        <div class="tab-content" id="myTabContent">
          <div class="tab-pane fade show active" id="processed" role="tabpanel" aria-labelledby="processed-tab">
            <table id="paymentProcessTable" class="table" style="width:100%">
              <thead>
              <tr>
                <th>Title</th>
                <th>Created on</th>
                <th>Tranferred on</th>
                <th>Amount</th>
                <th>Status</th>
                <th>Transferred to</th>
                <th></th>
              </tr>
              </thead>
            </table>
          </div>
          <div class="tab-pane fade" id="error" role="tabpanel" aria-labelledby="error-tab">
            <table id="paymentErrorTable" class="table" style="width:100%">
              <thead>
              <tr>
                <th>Title</th>
                <th>Created on</th>
                <th>Tranferred on</th>
                <th>Amount</th>
                <th>Status</th>
                <th>Transferred to</th>
              </tr>
              </thead>
            </table>
          </div>
        </div>
      </div>
      <preLoader v-show="isDataTableLoading === true"></preLoader>
    </template>

    <template v-else-if="merchantPayments === false">
      <notAllowed></notAllowed>
    </template>

    <template v-else-if="merchantPayments === null">
      <preLoader></preLoader>
    </template>
  </div>
</template>
<script>
var gThat = null;
export default {
  data() {
    return {
      data: null,
      merchantPayments: null,
      currentActiveTab : 'processed',
      isDataTableLoading : false,
      processtab : null,
      errortab : null,
    };
  },
  mounted() {
    gThat = this;
    this.$Progress.start();
    this.can("merchant_auto_sweep")
        .then(result => {
          this.merchantPayments = result.merchant_auto_sweep;
        })
        .then(result => {
          if (this.merchantPayments === true) {
            gThat.MerchantPaymentProcessList();
            gThat.MerchantPaymentErrorList();
          }
        });
  },

  methods: {
    MerchantPaymentProcessList: function () {
      var self = this;
      this.processtab = $("#paymentProcessTable").DataTable({
        processing: true,
        serverSide: true,
        responsive: true,
        ordering: false,
        ajax: {
          url: "api/getAutoSweepProcessedPayments",
          method: "get",
        }, columns: [
          {data: "name"},
          {data: "created_at"},
          {data: "updated_at"},
          {data: "payroll_amount"},
          {render: function(td, cellData, rowData, row, col){
              return 'Processed';
            }},
          {render: function(td, cellData, rowData, row, col){
              if(rowData.branch_code == null)
                return rowData.account_number;
              else
                return rowData.branch_code.concat(rowData.account_number);
            }},
          {render: function(td, cellData, rowData, row, col){
              return '<a href="javascript:void(0);" data-toggle="tooltip" data-placement="top" title="Download" class="action" style="text-align:center" onclick="VueComponents.merchantAutoSweepPaymentComponent.methods.downloadPaymentSlip('+ rowData.id+')" ><i class="fas fa-download"></i></a>';
            }}
        ],
      });
    },
    MerchantPaymentErrorList: function () {
      var self = this;
      this.errortab = $("#paymentErrorTable").DataTable({
        processing: true,
        serverSide: true,
        responsive: true,
        ordering: false,
        ajax: {
          url: "api/getAutoSweepErrorPayments",
          method: "get",
        }, columns: [
          {data: "name"},
          {data: "created_at"},
          {data: "updated_at"},
          {data: "payroll_amount"},
          {render: function(td, cellData, rowData, row, col){
                return 'Error';
            }},
          {render: function(td, cellData, rowData, row, col){
              if(rowData.branch_code == null)
                return rowData.account_number;
              else
                return rowData.branch_code.concat(rowData.account_number);
            }}
        ],
      });
    },
    downloadPaymentSlip: function(id){
      axios.get('/api/downloadPaymentSlip/'+id, {responseType: 'arraybuffer'})
          .then((response) => {
            if(response.status == 200 || response.status == 204){
              let blob = new Blob([response.data], { type: 'application/pdf' })
              let link = document.createElement('a')
              link.href = window.URL.createObjectURL(blob)
              link.download = 'Payment Slip.pdf'
              link.click();
              this.showToastBox('success','File downloaded successfully');
            }else{
              this.showAlertBox('error','Something went wrong, Please try again');
            }

          });
    },

    reloadList(tabClicked){
      switch(tabClicked)
      {
        case 'processed':
          if(gThat.currentActiveTab !== 'processed')
          {
            gThat.isDataTableLoading = true;

            gThat.processtab.ajax.reload(function(json){

              gThat.isDataTableLoading 		= false;
            }, false);

            gThat.currentActiveTab = 'processed';
          }
          break;

        case 'error':
          if(gThat.currentActiveTab !== 'error')
          {
            gThat.isDataTableLoading = true;

            gThat.errortab.ajax.reload(function(json){

              gThat.isDataTableLoading = false;
            }, false);

            gThat.currentActiveTab = 'error';
          }
          break;
      }
    }
  },
};
</script>
